module.exports = __webpack_public_path__ + "static/gabby-e5c4745a0db10271537cd739bdd36ee1.jpg";